import { Directive, ElementRef, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { UtilitiesService } from '../services/utilities.service';

@Directive({
    selector: '[clickOutside]',
    standalone: false
})
export class ClickOutsidemonthyearDirective implements OnInit {
    serVal: any;
    @Input()
     public triggered = false;
    constructor(private _elementRef: ElementRef, private utilitiesService: UtilitiesService) {
    }
    @Output()
    public clickOutside = new EventEmitter<MouseEvent>();

    ngOnInit() {
        this.serVal = this.utilitiesService.documentClickedTarget
            .subscribe(target => {
                this.documentClickListener(target)
            })
    }
    documentClickListener(event: any): void {
            let targetElement =  event['target'];
            if (!targetElement || targetElement == undefined) {
                return;
            }
            if (this.triggered) {
            const clickedInside = this._elementRef.nativeElement.contains(targetElement);
            if (!clickedInside) {
                this.clickOutside.emit(event);
            }
          }
    }
    ngOnDestroy() {
        if(this.serVal != undefined && this.serVal.unsubscribe != undefined){
            this.serVal.unsubscribe();
        }
    }
}
